export const courseId = process.env.REACT_APP_COURSE_ID || '';
export const courseWebsite = process.env.REACT_APP_COURSE_LINK || '';

